"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IwhiScales = exports.MedicareCardTypes = exports.IshiHospitalProducts = exports.GovernmentRebateAgeRanges = exports.ProductTypes = exports.IwhiExcesses = exports.Excesses = exports.PhoneNumberTypes = exports.Titles = exports.Genders = exports.States = exports.Scales = exports.IncomeTierNumbers = exports.IncomeTiers = exports.PaymentMethods = exports.PaymentFrequencies = exports.ResidentStatusCodes = exports.RHCACountry = exports.CoverOffering = exports.ResidencyStatus = exports.DependantTransferringFundType = exports.Selected = exports.ArhiFundIds = exports.ArhiFunds = exports.IdToFund = exports.FundToId = exports.Funds = exports.RateCode = exports.RequestType = exports.IwhiScale = exports.IshiUltimateProduct = exports.IshiHospitalProduct = exports.IshiTSScale = exports.IshiTSUltimateProductCode = exports.IshiTSHospitalProductCode = exports.GovernmentRebateAgeRange = exports.ProductType = exports.IwhiExcess = exports.APIAExcess = exports.Excess = exports.PhoneNumberType = exports.Title = exports.Gender = exports.State = exports.Scale = exports.IncomeTierNumber = exports.MedicareCardType = exports.IncomeTier = exports.PaymentMethod = exports.PaymentFrequency = void 0;
exports.RCHACountries = exports.CoverOfferings = exports.ResidencyStatusOptions = exports.DependantTransferringFundTypes = exports.RateCodes = exports.RequestTypes = void 0;
const utils_1 = require("./utils");
exports.PaymentFrequency = {
  Weekly: 'Weekly',
  Fortnightly: 'Fortnightly',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  HalfYearly: 'HalfYearly',
  Yearly: 'Yearly'
};
exports.PaymentMethod = {
  DirectDebit: 'DirectDebit',
  CreditCard: 'CreditCard',
  Braintree: 'Braintree',
  Group: 'Group'
};
exports.IncomeTier = {
  Tier0: 'Tier0',
  Tier1: 'Tier1',
  Tier2: 'Tier2',
  Tier3: 'Tier3',
  NoRebate: 'NoRebate'
};
exports.MedicareCardType = {
  Green: 'Green',
  Yellow: 'Yellow',
  Blue: 'Blue',
  None: 'None'
};
exports.IncomeTierNumber = {
  Tier0: 0,
  Tier1: 1,
  Tier2: 2,
  Tier3: 3
};
exports.Scale = {
  Single: 'Single',
  Couple: 'Couple',
  Family: 'Family',
  SingleParentFamily: 'SingleParentFamily',
  ExtendedFamily: 'ExtendedFamily'
};
exports.State = {
  NSW: 'NSW',
  QLD: 'QLD',
  TAS: 'TAS',
  NT: 'NT',
  VIC: 'VIC',
  SA: 'SA',
  WA: 'WA',
  ACT: 'ACT'
};
exports.Gender = {
  Male: 'Male',
  Female: 'Female'
};
exports.Title = {
  Mr: 'Mr',
  Mrs: 'Mrs',
  Miss: 'Miss',
  Ms: 'Ms',
  Mx: 'Mx',
  Dr: 'Dr',
  Prof: 'Prof',
  Sr: 'Sr',
  Rev: 'Rev',
  Father: 'Father',
  Brother: 'Brother',
  Bishop: 'Bishop',
  Sir: 'Sir',
  Lady: 'Lady',
  Captain: 'Captain',
  Colonel: 'Colonel',
  Major: 'Major',
  Lord: 'Lord'
};
exports.PhoneNumberType = {
  Unknown: 'Unknown',
  Home: 'Home',
  Work: 'Work',
  Mobile: 'Mobile'
};
exports.Excess = {
  0: 0,
  250: 250,
  500: 500,
  750: 750
};
exports.APIAExcess = {
  250: 250,
  500: 500,
  750: 750
};
exports.IwhiExcess = {
  0: 0,
  500: 500
};
exports.ProductType = {
  Hospital: 'Hospital',
  Ancillary: 'Ancillary',
  Combined: 'Combined'
};
exports.GovernmentRebateAgeRange = {
  AgeUnder65: 'AgeUnder65',
  Age65To69: 'Age65To69',
  Age70Plus: 'Age70Plus'
};
exports.IshiTSHospitalProductCode = 'OUS';
exports.IshiTSUltimateProductCode = 'OTS';
exports.IshiTSScale = {
  Single: 'S',
  Couple: 'D',
  Family: 'F',
  SingleParentFamily: 'P'
};
exports.IshiHospitalProduct = {
  Single: 'OUS',
  Couple: 'OUC',
  Family: 'OUF'
};
exports.IshiUltimateProduct = {
  Single: 'OTS',
  Couple: 'OTC',
  Family: 'OTF'
};
exports.IwhiScale = {
  Couple: 'T',
  Family: 'G',
  Single: 'W'
};
exports.RequestType = {
  ARHI: 'arhi',
  ISHI: 'ishi',
  IWHI: 'iwhi'
};
exports.RateCode = {
  OS5: 'OS5',
  OS6: 'OS6'
};
exports.Funds = {
  ARHI: 'ARHI',
  ISHI: 'ISHI',
  IWHI: 'IWHI',
  APIA: 'APIA',
  QANTAS: 'QANTAS',
  SUNCORP: 'SUNCORP',
  AAMI: 'AAMI',
  TAL: 'TAL',
  ING: 'ING',
  PRICELINE: 'PRICELINE',
  REAL: 'REAL',
  SENIORS: 'SENIORS',
  GU: 'GU'
};
exports.FundToId = {
  ARHI: '1',
  ISHI: '2',
  IWHI: '3',
  APIA: '4',
  QANTAS: '5',
  SUNCORP: '6',
  AAMI: '7',
  TAL: '8',
  ING: '9',
  PRICELINE: '10',
  REAL: '11',
  SENIORS: '12',
  GU: '14'
};
exports.IdToFund = {
  1: 'ARHI',
  2: 'ISHI',
  3: 'IWHI',
  4: 'APIA',
  5: 'QANTAS',
  6: 'SUNCORP',
  7: 'AAMI',
  8: 'TAL',
  9: 'ING',
  10: 'PRICELINE',
  11: 'REAL',
  12: 'SENIORS',
  14: 'GU'
};
exports.ArhiFunds = [exports.Funds.ARHI, exports.Funds.APIA, exports.Funds.ING, exports.Funds.SUNCORP, exports.Funds.AAMI, exports.Funds.PRICELINE, exports.Funds.REAL, exports.Funds.SENIORS, exports.Funds.GU];
exports.ArhiFundIds = exports.ArhiFunds.map(i => exports.FundToId[i]);
exports.Selected = {
  yes: 'yes',
  no: 'no',
  unselected: 'unselected'
};
exports.DependantTransferringFundType = {
  YesPolicyHolder: 'YesPolicyHolder',
  YesPartner: 'YesPartner',
  YesDifferentFund: 'YesDifferentFund',
  No: 'No'
};
exports.ResidencyStatus = {
  AustralianCitizen: 'AustralianCitizen',
  PermanentResident: 'PermanentResident',
  OverseasVisitor: 'OverseasVisitor'
};
exports.CoverOffering = {
  Both: 'Both',
  ARHI: 'ARHI',
  IWHI: 'IWHI'
};
// Constants used for GU, the list of countries of a customer when combined with permanent residence or citizenship
// that results in a RCHA classification
exports.RHCACountry = {
  NOR: 'NOR',
  FIN: 'FIN',
  UK: 'UK',
  IRE: 'IRE',
  ITL: 'ITL',
  MTA: 'MTA',
  NET: 'NET',
  NZ: 'NZ',
  SLO: 'SLO',
  SWE: 'SWE'
};
exports.ResidentStatusCodes = {
  RES: 'RES',
  RHCA: 'RHCA',
  NRHCA: 'NRHCA'
};
exports.PaymentFrequencies = (0, utils_1.values)(exports.PaymentFrequency);
exports.PaymentMethods = (0, utils_1.values)(exports.PaymentMethod);
exports.IncomeTiers = (0, utils_1.values)(exports.IncomeTier);
exports.IncomeTierNumbers = (0, utils_1.values)(exports.IncomeTierNumber);
exports.Scales = (0, utils_1.values)(exports.Scale);
exports.States = (0, utils_1.values)(exports.State);
exports.Genders = (0, utils_1.values)(exports.Gender);
exports.Titles = (0, utils_1.values)(exports.Title);
exports.PhoneNumberTypes = (0, utils_1.values)(exports.PhoneNumberType);
exports.Excesses = (0, utils_1.values)(exports.Excess);
exports.IwhiExcesses = (0, utils_1.values)(exports.IwhiExcess);
exports.ProductTypes = (0, utils_1.values)(exports.ProductType);
exports.GovernmentRebateAgeRanges = (0, utils_1.values)(exports.GovernmentRebateAgeRange);
exports.IshiHospitalProducts = (0, utils_1.values)(exports.IshiHospitalProduct);
exports.MedicareCardTypes = (0, utils_1.values)(exports.MedicareCardType);
exports.IwhiScales = (0, utils_1.values)(exports.IwhiScale);
exports.RequestTypes = (0, utils_1.values)(exports.RequestType);
exports.RateCodes = (0, utils_1.values)(exports.RateCode);
exports.DependantTransferringFundTypes = (0, utils_1.values)(exports.DependantTransferringFundType);
exports.ResidencyStatusOptions = (0, utils_1.values)(exports.ResidencyStatus);
exports.CoverOfferings = (0, utils_1.values)(exports.CoverOffering);
exports.RCHACountries = (0, utils_1.values)(exports.RHCACountry);